import { useEffect, useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./BookingManagement.module.css";
import TabBar from "components/tabBar/TabBar";
import BookingManagementTimeTable from "./BookingManagementTimeTable";
import BookingManagementBookingTable from "./BookingManagementBookingTable";
import BookingManagementCancelTable from "./BookingManagementCancelTable";
import { LuCalendarDays } from "react-icons/lu";
import { getParentKids } from "services/get-parents-kids";
import { KidsData } from "modules/profile";
import { getParentBookingCounter } from "services/booking/get-parent-booking-counter";

interface BookingManagementProps {
    activeTab: string;
    onTabClick: (tabId: string) => void;
}

export default function BookingManagement({ activeTab, onTabClick }: BookingManagementProps) {
    const [bookingCount, setBookingCount] = useState(0);
    const [cancelCount, setCancelCount] = useState(0);

    const fetchData = async () => {
        try {
            const kidsDataRes = await getParentKids();
            if (kidsDataRes.kids && kidsDataRes.kids.length > 0) {
                const kidIds = kidsDataRes.kids.map((kid: KidsData) => kid.id);
                if (kidIds.length > 0) {
                    const kidsBookingsCountData = await getParentBookingCounter(kidIds);
                    setBookingCount(parseInt(kidsBookingsCountData.data.booking_counter, 10) || 0);
                    setCancelCount(parseInt(kidsBookingsCountData.data.cancel_counter, 10) || 0);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const tabs = [
        { id: "overview", label: "Übersicht" },
        { id: "bookings", label: `Buchungen (${bookingCount})` },
        { id: "cancellations", label: `Stornierungen (${cancelCount})` },
    ];

    return (
        <div className={styles.container}>
            <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                <LuCalendarDays className={commonStyles.sectionTitleIcon} />
                <h1>Buchungsverwaltung</h1>
            </div>

            <TabBar tabs={tabs} activeTab={activeTab} onTabClick={onTabClick} />

            <div className={styles.tabContent}>
                {activeTab === "overview" && <BookingManagementTimeTable />}
                {activeTab === "bookings" && <BookingManagementBookingTable />}
                {activeTab === "cancellations" && <BookingManagementCancelTable />}
            </div>
        </div>
    );
}
